import { AuditFormQuestionDto } from './auditFormQuestion.dto';
import { BaseDto } from '../base.dto';

export class AuditFormQuestionOptionDto extends BaseDto {
  text: string;
  guidance?: string;
  isSelected?: boolean;
  points?: number;
  question: AuditFormQuestionDto;
  sort?: number;
  isDeleted?: boolean;
}
